import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  initColumn,
  columnAnimation,
  datasetXY,
  xBand,
  yLinear,
  percent,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  pivotAdapter,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  stackInverse,
  columnStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  verticalCrosshairRect,
  barCornerRadius,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorBarStyleFill,
  pivotColorLegend,
  barMaxWidth,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const columnPercent: VChartSpecPipeline = [
  fontFamilyTheme,
  initColumn,
  columnAnimation,
  regionPadding,
  barCornerRadius,
  stackInverse,
  barMaxWidth,
  colorAdapter(color, linearColor),
  backgroundColor,
  percent,
  datasetXY,
  animationMorph,
  progressive,
  xBand,
  yLinear,
  label,
  brush,
  tooltip({ titleEncoding: 'x' }),
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairRect,
  colorBarStyleFill(columnStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
]

const pivotColumnPercent: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initColumn,
    columnAnimation,
    regionPadding,
    barCornerRadius,
    stackInverse,
    barMaxWidth,
    colorAdapter(color, linearColor),
    percent,
    backgroundColor,
    datasetXY,
    animationMorph,
    progressive,
    xBand,
    pivotAxisStyle(yLinear),
    brush,
    label,
    tooltip({ titleEncoding: 'x' }),
    verticalCrosshairRect,
    colorBarStyleFill(columnStyle),
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationAreaBand,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const columnPercentSpecPipeline = [pivotAdapter(columnPercent, pivotColumnPercent)]
